export default __webpack_public_path__ + "static/niw_eng-273568327afdf47fbd6ff9f4fdbfae6f.png";